module.exports = __webpack_public_path__ + "static/media/banner-mobile.b6afe6d6.png";